import 'core-js/stable/string/includes';
import 'core-js/stable/string/starts-with';
import 'core-js/stable/array/includes';
import 'core-js/stable/array/find';
import 'core-js/stable/array/from';
import 'core-js/stable/object/assign';
import 'core-js/stable/object/get-own-property-symbols';
import 'core-js/stable/url';
import 'core-js/stable/number/is-nan';
import 'whatwg-fetch';
import 'promise-polyfill/lib/polyfill';

(() => {
    if (typeof window.CustomEvent === 'function') {
        return;
    }
    const DEFAULT_EVENT_PARAMS = {
        bubbles: false,
        cancelable: false,
        detail: undefined,
    };

    function CustomEvent(event: string, params: typeof DEFAULT_EVENT_PARAMS) {
        const { bubbles, cancelable, detail } = Object.assign(
            {},
            DEFAULT_EVENT_PARAMS,
            params,
        );
        const evt = document.createEvent('CustomEvent');
        if (evt.initCustomEvent) {
            evt.initCustomEvent(event, bubbles, cancelable, detail);
        }
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    // @ts-expect-error CustomEvent override is ok
    window.CustomEvent = CustomEvent;
})();
